<div class="ug-container">
  <app-title-container>
    <h1>Assessment Guide</h1>
  </app-title-container>

  <app-divider height="2px"></app-divider>
  <div class="overflow-content">
    @if (isLoading()) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    } @else {
      <div class="actions-container" *appIsRiskManager>
        @if (!isEditMode()) {
          <button
            class="clickable-text ml-auto"
            (click)="toggleEditMode()"
            aria-label="Edit Assessment Guide"
            matTooltip="Edit Assessment Guide"
          >
            <span class="material-symbols-outlined action-icon"> edit </span>
          </button>
        }
      </div>

      @if (isEditMode()) {
        <div class="editable-container">
          <quill-editor bounds="self" class="quill-editor-container" [formControl]="descriptionControl"></quill-editor>
          <div>
            <button mat-button (click)="toggleEditMode()" matTooltip="Cancel changes">Cancel</button>
            <button mat-flat-button (click)="updateManual()" matTooltip="Update Assessment Guide">
              <mat-icon fontIcon="check"></mat-icon> Submit
            </button>
          </div>
        </div>
      } @else {
        <div class="viewable-container">
          <quill-view class="white-section" [content]="descriptionControl.value" format="html"></quill-view>
        </div>
      }
      @if (userGuideTexts(); as texts) {
        <div class="table-container">
          <table>
            <thead>
              <tr>
                <th scope="col" style="width: 10%"><h4>Symbol</h4></th>
                <th scope="col" style="width: 10%"><h4>Title</h4></th>
                <th scope="col" style="width: 80%"><h4>Description</h4></th>
              </tr>
            </thead>
            <tbody>
              @for (level of sensitivityLevels; track level) {
                <tr>
                  <td class="table-img">
                    <img [src]="texts[level].image" alt="" />
                  </td>
                  <td>
                    <div [innerHTML]="texts[level].title"></div>
                  </td>
                  <td class="table-desc">
                    <div [innerHTML]="texts[level].description"></div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
          @if (texts.bottomDescription) {
            <div class="bottom-description">
              <h3>Additional Info</h3>
              <div [innerHTML]="texts.bottomDescription"></div>
            </div>
          }
        </div>
      }
    }
  </div>
</div>
